import React  from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import SplashScreen from "../screens/SplashScreen";
import LoginScreen from "../screens/LoginScreen";
import DrawerNav from "./DrawerNav";
import CustomerLocationScreen from "../screens/CustomerLocationScreen";
import FillCustomerAddressScreen from "../screens/FillCustomerAddressScreen";
import ReqeustInfoScreen from "../screens/ReqeustInfoScreen";
import NewAddressBookScreen from "../screens/NewAddressBookScreen";
import NewFavoritPersonScreen from "../screens/NewFavoritPersonScreen";
import ServiceListScreen from "../screens/ServiceListScreen";
import ServiceInfoListScreen from "../screens/ServiceInfoListScreen";
import ViewCartScreen from "../screens/ViewCartScreen";
import CompleteOrderScreen from "../screens/CompleteOrderScreen";
import CurrentOrderScreen from "../screens/CurrentOrderScreen";
import AddFavoritExpertScreen from "../screens/AddFavoritExpertScreen";
import strings from "../theme/strings";
import InsuranceListScreen from '../screens/InsuranceListScreen';


const Stack = createStackNavigator();


export default function PrimaryNav() {
    return <Stack.Navigator
        headerMode='none'
        initialRouteName="splash">
        <Stack.Screen name="splash" component={SplashScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="login" component={LoginScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="main" component={DrawerNav} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="customerLocation" component={CustomerLocationScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="fillAddress" component={FillCustomerAddressScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="insurance" component={InsuranceListScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="services" component={ServiceListScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="serviceInfo" component={ServiceInfoListScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="createFavoritPerson" component={NewFavoritPersonScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="addFavoritExpert" component={AddFavoritExpertScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="createAddressBook" component={NewAddressBookScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="viewCart" component={ViewCartScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="completeOrder" component={CompleteOrderScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="requestInfo" component={ReqeustInfoScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="currentOrder" component={CurrentOrderScreen} options={{ title: strings.asanDarman }} />
    </Stack.Navigator>
}
